module.exports = __webpack_public_path__ + "static/media/bv.ed567108.svg";